import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import WhatWaitingForYouSection from "@/components/WhatWaitingForYouSection";
import UpcomingEventsSection from "@/components/UpcomingEventsSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import RegistrationForm from "@/components/QuestionForm";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import EventTypesSection from "@/components/TypesOfEventsSection";
import PartnersInvitationSection from "@/components/PartnersInvitationSection";
import SignupModalController from "@/components/controllers/SignupModalController";


export default function Index() {
  return (
    <div className="bg-white">
      <Header />
      <HeroSection />
      <AboutSection />
      <WhatWaitingForYouSection />
      <EventTypesSection />
      <UpcomingEventsSection />
      {/* <TestimonialsSection /> */}
      <FAQSection />
      <PartnersInvitationSection />
      <RegistrationForm />

      <SignupModalController />

      <Footer />
    </div>
  );
}
